import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'maskToken'
})
export class MaskTokenPipe implements PipeTransform {
  transform(token: string): string {
    if (!token || token.length < 8) return token;
    return `${token.substring(0, 4)}****${token.substring(token.length - 4)}`;
  }
}
